export default __webpack_public_path__ + "static/media/uv11_en_star_b1.c0b6cc8f.mp3";